import api from '../../ApiConfig';
import { Apis } from '../../config';

import { Alerts } from '../index'
const getUserLogin = async (data) => {
    try {
        let result = await api.post(Apis.UserLogin, data);
        if (result.data.error) {
            return null;
        }
        return result.data;
    } catch (error) {
        // if (error.response.status === 422) {
        //     Alerts.alertMessage(error.response.data, "Sorry !", "danger");
        // }
        console.log(error);
        return null;
    }
};

const getUserDetails = async () => {
    try {
        var token =  sessionStorage.getItem('userToken');
        let result = await api.get(Apis.GetUserProfile, {
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
        
    } catch (error) {
        if (error.response.status === 422) {
            Alerts.alertMessage(error.response.data, "Sorry !", "danger");
        }
        return null;
    }
};




const getUserProfileUpdate = async (data) => {
    try {
       
        var token =  sessionStorage.getItem('userToken');
        let result = await api.put(Apis.UserProfileUpdate, data, {
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
        
    } catch (error) {
        if (error.response.status === 422) {
            Alerts.alertMessage(error.response.data, "Sorry !", "danger");
        }
        return null;
    }
};


const checkUserCurrentPassword = async (data) => {
    try {
       
        var token =  sessionStorage.getItem('userToken');
        let result = await api.post(Apis.CheckUserCurrentPassword, data, {
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
        
    } catch (error) {
        if (error.response.status === 422) {
            Alerts.alertMessage(error.response.data, "Sorry !", "danger");
        }
        return null;
    }
};

const getUserPasswordUpdate = async (id, data) => {
    try {
       
        var token =  sessionStorage.getItem('userToken');
        let result = await api.put(Apis.UserPasswordUpdate, data, {
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
        
    } catch (error) {
        if (error.response.status === 422) {
            Alerts.alertMessage(error.response.data, "Sorry !", "danger");
        }
        return null;
    }
};



const exportedObject = {
    getUserLogin,
    getUserDetails,
    getUserProfileUpdate,
    checkUserCurrentPassword,
    getUserPasswordUpdate
};
export default exportedObject;